import { Component } from '@angular/core';
import { benefits } from './benefits-object';

@Component({
  selector: 'app-reasons-to-love-ketto',
  templateUrl: './reasons-to-love-ketto.component.html',
  styleUrls: ['./reasons-to-love-ketto.component.scss']
})
export class ReasonsToLoveKettoComponent {
  public benefits: { imgClass: string, heading: string, description: string }[] = benefits;
  constructor() { }
}
